import { Fragment } from 'react';
import { Link } from 'react-router-dom';

import {
  Breadcrumb as ShadcnBreadcrumb,
  BreadcrumbItem as ShadcnBreadcrumbItem,
  BreadcrumbLink as ShadcnBreadcrumbLink,
  BreadcrumbList as ShadcnBreadcrumbList,
  BreadcrumbPage as ShadcnBreadcrumbPage,
  BreadcrumbSeparator as ShadcnBreadcrumbSeparator,
} from '../../../shadcn/components/ui/breadcrumb';

import { useBreadcrumb } from './breadcrumb-context';

const MIN_CRUMBS = 2;

interface BreadcrumbItem {
  readonly label: string;
  readonly href?: string;
}

const BreadcrumbEntry = ({ label, href }: BreadcrumbItem) => (
  <ShadcnBreadcrumbItem className={`!text-abyssyl-blue-dark ${href ? 'shrink-0 ' : 'min-w-0'}`}>
    {href ? (
      <ShadcnBreadcrumbLink asChild className="underline">
        <Link to={href}>{label}</Link>
      </ShadcnBreadcrumbLink>
    ) : (
      <ShadcnBreadcrumbPage className="truncate">{label}</ShadcnBreadcrumbPage>
    )}
  </ShadcnBreadcrumbItem>
);

const Breadcrumb = () => {
  const { crumbs } = useBreadcrumb();
  if (crumbs.length < MIN_CRUMBS) return null;

  return (
    <ShadcnBreadcrumb className="py-4 ">
      <ShadcnBreadcrumbList className="flex-nowrap gap-1">
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <Fragment key={crumb.label}>
              <BreadcrumbEntry href={isLast ? undefined : crumb.href} label={crumb.label} />
              {!isLast && <ShadcnBreadcrumbSeparator />}
            </Fragment>
          );
        })}
      </ShadcnBreadcrumbList>
    </ShadcnBreadcrumb>
  );
};

export { Breadcrumb };
export type { BreadcrumbItem };
